import React, { Fragment, useEffect } from 'react';
import { H4, H5, LI, P, UL } from '../../../../AbstractElements';
import { Clock, Users, MapPin, Calendar, User } from 'react-feather';
import { Card, CardBody, Badge } from 'reactstrap';

const BrandShipping = ({ event }) => {
  // Add CSS for pulse animation
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  // Function to determine event status based on current time
  const getEventStatus = (event) => {
    if (!event || !event.startTime || !event.endTime) {
      return 'unknown';
    }

    const now = new Date();
    const startTime = new Date(event.startTime);
    const endTime = new Date(event.endTime);

    if (now < startTime) {
      return 'upcoming';
    } else if (now >= startTime && now <= endTime) {
      return 'now';
    } else {
      return 'ended';
    }
  };

  const getStatusBadge = (event) => {
    const status = getEventStatus(event);
    
    switch (status) {
      case 'now':
        return <Badge color="success" style={{
          animation: 'pulse 2s infinite',
          boxShadow: '0 0 10px rgba(40, 167, 69, 0.3)'
        }}>
          <i className="fa fa-play me-1"></i>
          Đang diễn ra
        </Badge>;
      case 'ended':
        return <Badge color="secondary">
          <i className="fa fa-check me-1"></i>
          Đã kết thúc
        </Badge>;
      case 'upcoming':
        return <Badge color="info">
          <i className="fa fa-clock me-1"></i>
          Sắp diễn ra
        </Badge>;
      default:
        return <Badge color="warning">
          <i className="fa fa-question me-1"></i>
          Chưa xác định
        </Badge>;
    }
  };

  if (!event) {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <div className="text-center py-4">
              <p>Không có thông tin sự kiện</p>
            </div>
          </CardBody>
        </Card>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Card className="shadow-sm border-0 mb-3">
        <CardBody className="p-4">
          <div className='filter-block'>
            <H4 className="text-dark mb-3">Thông tin sự kiện</H4>
            <div className="row g-3">
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <i className="fa fa-tag text-info me-3 mt-1" style={{width: '20px'}}></i>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Loại sự kiện</small>
                    <span className="fw-medium">{event.formattedType}</span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <i className="fa fa-info-circle text-primary me-3 mt-1" style={{width: '20px'}}></i>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Trạng thái</small>
                    {getStatusBadge(event)}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <i className="fa fa-calendar text-success me-3 mt-1" style={{width: '20px'}}></i>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Ngày</small>
                    <span className="fw-medium">{event.formattedDate}</span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <i className="fa fa-clock text-warning me-3 mt-1" style={{width: '20px'}}></i>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Thời gian</small>
                    <span className="fw-medium">{event.formattedDateTime}</span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <i className="fa fa-users text-secondary me-3 mt-1" style={{width: '20px'}}></i>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Số lượng</small>
                    <span className="fw-medium">{event.formattedMaxAttendees} người</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      
      <Card className="shadow-sm border-0">
        <CardBody className="p-4">
          <div className='collection-filter-block'>
            <H4 className="text-dark mb-3">Chi tiết sự kiện</H4>
            <div className="row g-3">
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <MapPin className="text-primary me-3 mt-1" size={20} style={{width: '20px'}} />
                  <div className="flex-grow-1">
                    <H5 className="text-dark mb-1">Địa điểm</H5>
                    <P className="text-muted mb-0 lh-base">{event.location || 'Chưa xác định'}</P>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <User className="text-success me-3 mt-1" size={20} style={{width: '20px'}} />
                  <div className="flex-grow-1">
                    <H5 className="text-dark mb-1">Người tổ chức</H5>
                    <P className="text-muted mb-0">{event.organizer || 'Chưa xác định'}</P>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <Users className="text-info me-3 mt-1" size={20} style={{width: '20px'}} />
                  <div className="flex-grow-1">
                    <H5 className="text-dark mb-1">Số lượng tham gia</H5>
                    <P className="text-muted mb-0">{event.formattedMaxAttendees} người</P>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <Calendar className="text-warning me-3 mt-1" size={20} style={{width: '20px'}} />
                  <div className="flex-grow-1">
                    <H5 className="text-dark mb-1">Thời gian</H5>
                    <P className="text-muted mb-0">{event.formattedDateTime}</P>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default BrandShipping;
